import { ArticleHeading4 } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

interface IHeaderProps {
  title?: string;
  onClose(): void;
}

export const Header = ({ title, onClose }: IHeaderProps) => {
  return (
    <div className={classNames(styles['header'], title && styles['header_title'])}>
      {title && <ArticleHeading4>{title}</ArticleHeading4>}
      <IconActionClose16 onClick={onClose} />
    </div>
  );
};
